import React from 'react';
import { motion } from 'framer-motion';
import { tomoTags } from '../../data/content';
export function ProductReveal() {
  return <section className="py-24 relative overflow-hidden bg-pistachio-100 border-t border-line" data-id="element-234" data-mp="3qobh3s48s9qa">
      <div className="container mx-auto px-4 relative z-10" data-id="element-235" data-mp="3vm3bcssd07xn">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-4xl mx-auto" data-id="element-236" data-mp="48pddrxlf060">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-surface text-pistachio-700 mb-6 border border-line" data-id="element-237" data-mp="d8cdmael5zxh">
            <span className="text-3xl" aria-hidden="true" data-id="element-238" data-mp="i8rq6zr1n3ee">
              🏆
            </span>
          </div>

          <h2 className="text-sm font-bold tracking-widest text-pistachio-700 uppercase mb-4" data-id="element-239" data-mp="n4yxowz38myg">
            Close The Gap™
          </h2>

          <p className="font-display font-bold text-ink mb-6 text-4xl sm:text-5xl md:text-6xl" data-id="element-240" data-mp="2oxwn0itnoxen">
            MEGA PACK COCINA LISTA + SISTEMA TOTAL
          </p>

          <p className="text-xl md:text-2xl text-ink/80 mb-4 font-medium" data-id="element-241" data-mp="2c109yoawuqzq">
            6 Tomos + 6 Bonos + Método Cocina Impecable
          </p>

          <p className="text-lg text-muted mb-12" data-id="element-242" data-mp="228ck6diclnai">
            310+ páginas · Todo resuelto · Listo para usar desde hoy
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-243" data-mp="1y9dh6yg6g0lp">
            {tomoTags.map((tomo, i) => <div key={tomo} className="px-4 py-2 rounded-lg bg-surface border border-line text-sm font-medium text-ink/80" data-id="element-244" data-mp="2uvp4si4y7l16" data-mpi={i}>
                <span className="text-pistachio-600 mr-2" data-id="element-245" data-mp="2lvs8bucbhhvk">Tomo {i + 1}</span> {tomo}
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}